module.exports = __webpack_public_path__ + "media/icons/car-insurance-48e6ae56.svg";